import "./home.css";
import A from "../img/bg.mp4";
import B from "../img/logo.png";
import React, { useState } from "react";
import { Helmet } from 'react-helmet-async';

const Home = () => {
  const current = new Date();
  const date = `${current.getDate()}/${current.getMonth()+1}/${current.getFullYear()}`;
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  
  const scrollToManifesto = (e) => {
    e.preventDefault();
    const manifestoSection = document.getElementById('manifesto');
    if (manifestoSection) {
      manifestoSection.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <main className="h">
      <Helmet>
        <title>Bichitras - Global Engineering Studio | Software Development & 3D Modeling Outsourcing</title>
        <meta name="description" content="We're not an agency. We are engineers who build, design, and move ideas forward. Global engineering studio offering software development, 3D modeling, and talent outsourcing services." />
        <meta property="og:title" content="Bichitras - Global Engineering Studio | Software Development & 3D Modeling Outsourcing" />
        <meta property="og:description" content="We're not an agency. We are engineers who build, design, and move ideas forward. Global engineering studio offering software development, 3D modeling, and talent outsourcing services." />
        <meta name="keywords" content="engineering studio, software development, 3D modeling, global outsourcing, Nepal engineering, talent hiring, business solutions" />
      </Helmet>
      <header className="h-main">
        <div className="logo">bichitras</div>
        
        {/* Desktop Navigation */}
        <nav className="nav-links" role="navigation" aria-label="Main navigation">
          <a href="#recent-cases" className="Button" aria-label="View our recent cases">Cases</a>
          <a href="#blog" className="Button" aria-label="Read our blog">Blog</a>
          <a href="/people" className="Button" aria-label="Meet our people">People</a>
          <a href="/jobs" className="Button" aria-label="View job openings">Jobs</a>
          <a href="#contact" className="Button" aria-label="Contact us">Contact</a>
        </nav>
        
        {/* Mobile Hamburger Menu */}
        <button 
          className={`hamburger-menu ${isMenuOpen ? 'open' : ''}`} 
          onClick={toggleMenu}
          aria-label="Toggle navigation menu"
          aria-expanded={isMenuOpen}
        >
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
        </button>
        
        {/* Mobile Navigation Menu */}
        <nav className={`mobile-nav ${isMenuOpen ? 'open' : ''}`} role="navigation" aria-label="Mobile navigation">
          <a href="#recent-cases" className="mobile-nav-link" onClick={toggleMenu}>Cases</a>
          <a href="#blog" className="mobile-nav-link" onClick={toggleMenu}>Blog</a>
          <a href="/people" className="mobile-nav-link" onClick={toggleMenu}>People</a>
          <a href="/jobs" className="mobile-nav-link" onClick={toggleMenu}>Jobs</a>
          <a href="#contact" className="mobile-nav-link" onClick={toggleMenu}>Contact</a>
        </nav>

        <nav className="langu" role="navigation" aria-label="Language selection">
          <a href="/?lang=np" className="Button" aria-label="Switch to Nepali language">NP</a>
          <a href="/?lang=en" className="Button" aria-label="Switch to English language">EN</a>
        </nav>
        
        <h1 className="heading">We're not <br className="mobile-break" />an agency.</h1>
        <div className="view">
          <a href="#manifesto" className="Button-view" onClick={scrollToManifesto} aria-label="View our manifesto">View Manifesto</a>
        </div>
        <time className="date">{date}</time>
        <div className="company">
          <img src={B} alt="Bichitras Engineering Studio Logo" className="ck" />
        </div>
        <video loop muted autoPlay className="backdrop" aria-label="Background video showcasing our work">
          <source src={A} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </header>
    </main>
  );
};

export default Home;